import { initializeApp, getApps, getApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import firebaseConfig from 'configs/FirebaseConfig'
import { VAPID_KEY } from 'configs/AppConfig'

/** App + messaging only — do not call getAuth here (triggers identitytoolkit getProjectConfig). */
const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
const messaging = getMessaging(app)

let authInstance = null
let googleAuthProviderInstance = null
let facebookAuthProviderInstance = null

/** Lazy Firebase Auth — only loads identitytoolkit when password-reset / social auth needs it. */
export const getFirebaseAuth = async () => {
  if (authInstance) {
    return {
      auth: authInstance,
      googleAuthProvider: googleAuthProviderInstance,
      facebookAuthProvider: facebookAuthProviderInstance,
    }
  }

  const { getAuth, GoogleAuthProvider, FacebookAuthProvider } = await import(
    'firebase/auth'
  )
  authInstance = getAuth(app)
  googleAuthProviderInstance = new GoogleAuthProvider()
  facebookAuthProviderInstance = new FacebookAuthProvider()

  return {
    auth: authInstance,
    googleAuthProvider: googleAuthProviderInstance,
    facebookAuthProvider: facebookAuthProviderInstance,
  }
}

export { app, messaging, getToken }

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission()

    if (permission !== 'granted') {
      throw new Error('Notification permission not granted.')
    }

    const token = await getToken(messaging, { vapidKey: VAPID_KEY })

    if (token) {
      return token
    }

    throw new Error('Failed to retrieve FCM token.')
  } catch (error) {
    console.error('Error getting FCM token: ', error)
    throw error
  }
}
